export const ROUTES = {
  tours: 'tours',
  blogs: 'blogs',
  reviews: 'reviews',
  gallery: 'gallery',
};
